/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class HorseVaccination {
    'id'?: number;
    'datePerformed'?: string;
    'vaccinationName'?: string;
    'dateNextDose'?: string;
    'addedBy': SimpleUser;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "datePerformed",
            "baseName": "datePerformed",
            "type": "string",
            "format": "date"
        },
        {
            "name": "vaccinationName",
            "baseName": "vaccinationName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dateNextDose",
            "baseName": "dateNextDose",
            "type": "string",
            "format": "date"
        },
        {
            "name": "addedBy",
            "baseName": "addedBy",
            "type": "SimpleUser",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseVaccination.attributeTypeMap;
    }

    public constructor() {
    }
}

